<template>
  <div class="ytgcsjf">
    <div class="calc-templete">
      <h6>岩土工程设计收费计算模版</h6>
      <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit" labelWidth="195px">
        <t-row style="height: auto;align-items: stretch;">
          <t-col :span="6"
            style="border-right: 1px solid #DADDE1;padding-left: 40px;padding-right: 140px;padding-bottom: 50px;height: auto;">
            <div class="left-top-title"><span>岩土工程设计费</span></div>
            <t-form-item label="计算依据">
              <a class="file-name" v-if="fileList" @click="fileOpenDialog(fileList.url)">{{fileList.fileName }}</a>
              <a v-else class="no-file-name">无文件</a>
             
            </t-form-item>
            <t-form-item label="工程名称" name="projectName">
              <t-input v-model="formData.projectName" placeholder="请输入工程名称"></t-input>
            </t-form-item>
            <t-form-item label="岩土工程概算额" name="money">
              <t-input-number v-model="formData.money" placeholder="请输入岩土工程概算额" suffix="万元" type="number" :min="0" theme="normal"></t-input-number>
            </t-form-item>
            
            <t-form-item name="complexityCoefficient" label="复杂程度调整" class="form-item-left">
              <t-input v-model="complexityCoefficient" placeholder="请选择工程复杂程度调整系数" ></t-input>
              <t-button theme="default" variant="outline" class="coefficient" @click="openVisible2">系数说明
                <img src="@/assets/icon/Vector.svg" style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
              </t-button>
            </t-form-item>
            
            
            <t-form-item label="浮动幅度" name="floatingRate">
              <t-input-number v-model="floatingRate"  placeholder=""  suffix="%"  :min="0"  theme="normal" ></t-input-number>

            </t-form-item>
            <t-form-item label="让利利率" name="discountRate">
              <t-input-number v-model="discountRate"  placeholder="" label="-" suffix="%" type="number" :min="0" :max="100" theme="normal" />

            </t-form-item>
            <t-button theme="primary" type="submit" class="submit">提交结果</t-button>
          </t-col>
          <t-col :span="6" style="padding-left: 106px;padding-right: 70px;padding-bottom: 50px;">
            <div class="right-top-title"><span>计算结果</span></div>
            <t-form-item name="subtotal" class="form-item-left">
              <span slot="label">
                <!-- <img src="@/assets/icon/icon1.svg" class="form-itme-icon"> -->
                收费基价
              </span>
              <t-input v-model="formData.subtotal" placeholder="" disabled suffix="元"></t-input>

            </t-form-item>
           
            <t-form-item label="计算过程">
              <t-textarea v-model="jsgc" placeholder="" disabled :autosize="{ minRows: 3, maxRows: 5 }"></t-textarea>
            </t-form-item>
            <t-form-item label="折后工程设计" name="result">
              <t-input v-model="formData.result" placeholder="" disabled suffix="元" @change="resultChange"></t-input>
            </t-form-item>
            <t-form-item label="金额大写" name="resultChinese">
              <t-input v-model="resultChinese" placeholder="" disabled></t-input>
            </t-form-item>
            <!-- <t-button class="download" @click="downLoad" :disabled="!formData.result"
              :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button> -->
              <t-button class="download" @click="downLoadWord" :disabled="!formData.result"
              :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button>
          </t-col>
        </t-row>

      </t-form>
    </div>

    <div class="calc-rules">
      <t-row>
        <t-col :span="6" style="border-right: 1px solid #DADDE1;">
          <h4><span>设计服务费计算范围和计算公式</span></h4>
        </t-col>
        <t-col :span="6">
          <h4><span>费率标准</span></h4>
        </t-col>
      </t-row>
      <div class="calc-rules-value">
         <t-row style="height: auto; align-items: stretch;">
          <t-col :span="6" style="border-right: 1px solid #DADDE1;">
            <div class="calc-rules-value-left">
              <div class="title"><span>计算范围</span></div>
              <div class="info">{{ calculateRange }}</div>
              <div class="title" style="margin-top: 33px;"><span>计算公式</span></div>
              <div class="info" style="white-space: pre-line;" >{{ calculationFormula }}</div>
            </div>
          </t-col>
          <t-col :span="6" style="padding: 20px;overflow: auto;" class='rate-table'>
            <div class="calc-rules-value-right">
              <t-table bordered row-key="index" :data="data" :columns="columns" />
              <div style="text-align: left;">注：费率标准按照Ⅰ级、Ⅱ级、Ⅲ级顺序划分。</div>
            </div>
          </t-col>
        </t-row>
      </div>
    </div>

    <t-dialog placement="center" :visible="visible2" :footer="false" :onConfirm="close2" :onClose="close2"
      class="dialog2">
      <span slot="header">
        工程复杂程度调整系数
        <div class="closeButton" @click="close2"></div>
      </span>
      <t-form style="    padding: 0 25%;
    margin-top: 20px;">
        <t-form-item label="工程类型" name="complexityCoefficient">
          <t-cascader class="custom-cascader-1" :options="complexityCoefficientList" clearable key="id"
            :keys="{ value: 'id', label: 'name', children: 'children' }"
            @change="changecomplexityCoefficient"></t-cascader>
          </t-form-item></t-form>
      <p>复杂程序</p>
      <t-space>
        <t-radio-group v-model="value2" @change="onChange2">
          <t-radio :value="item.name" v-for="item in this.complexityRadioGroupList" :key="item.id">
            {{ item.name }} <span></span>

          </t-radio>
          <!-- <t-radio value="较复杂（Ⅱ级）-1.0">较复杂（Ⅱ级） <span>1.0</span></t-radio>

          <t-radio value="复杂（Ⅲ级）-1.15">复杂（Ⅲ级） <span>1.15</span></t-radio> -->
        </t-radio-group>
      </t-space>
      <template>

        <t-table class="complexity-table" bordered row-key="id" :data="this.complexityRadioGroupList"
          :columns="complexitycolumns">
          <template #name="{ row }">
            <!-- 在此处通过 v-html 显示 HTML 内容 -->
            <div>{{ row.name.split('-')[0] }}</div>
          </template>
          <template #features="{ row }">
            <!-- 在此处通过 v-html 显示 HTML 内容 -->
            <div v-html="row.features"></div>

          </template>
        </t-table>
        <div v-show="this.complexityRemark" v-html="this.complexityRemark" style="text-align: left;
    padding: 20px;padding-top: 0px;"></div>
      </template>

    </t-dialog>
    <file-view v-bind:visible.sync="visible" :fileUrl="openFileUrl" :downFileUrl="downFileUrl"></file-view>
  </div>
</template>

<script>
import { getytgcsjf } from '@/api/data'
import { listRate } from "@/api/rate";
import { listFile } from "@/api/file";

export default {
  name: 'ytgcsjfFee',
  components: {

  },
  data() {
    return {
      jsgc: null,
      visible: false,
      downFileUrl:null,
      openFileUrl: null,
      downLoading: false,
      validateMessage: {
        projectName: [
          {
            type: 'error',
            message: '项目名称不能为空',
          },
        ],
        money: [
          {
            type: 'error',
            message: '请输入规范数字',
          },
        ]

      },
      rules: {
        projectName: [{ required: true }, { type: 'warning' }],
        money: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],

        
      },

      helpOpen: false,
      downData: {},
      value2: '',
      visible2: false,
      complexityCoefficient:null,
      floatingRate: null,
      discountRate: null,
      formData: {
        projectName: '',
        ificationId: this.$route.query.ification,
        money: null, //计算造价
        subtotal: null, //工程设计收费基价
        complexityCoefficient: null,//工程复杂程度调整系数
        floatingRate:0,
        discountRate: 0,
        discountRateMoney: null,
        result: null
      },
      complexityCoefficientList: [],
      complexityRadioGroupList: [],
      complexityList: [
        {
          id:'1',
          name:'地基处理',
          parentId:'0'
        },
        {
          id:'2',
          name:'Ⅰ级',
          parentId:1,
          features:'对地基基础变形无严格要求的建筑物，工程地质条件简单,地下水条件简单，对施工影响轻微。'
        },
        {
          id:'3',
          name:'Ⅱ级',
          parentId:'1',
          features:'对地基基础变形有一定要求的建筑物，工程地质条件较复杂,地下水条件较复杂，对施工影响较严重。'
        },
        {
          id:'4',
          name:'Ⅲ级',
          parentId:'1',
          features:'对地基基础变形有严格要求的建筑物，工程地质条件复杂,地下水条件复杂，对施工影响严重。'
        },
        {
          id:'5',
          name:'基坑支护',
          parentId:'0'
        },
        {
          id:'6',
          name:'Ⅰ级',
          parentId:'5',
          features:'基坑深度H<6.0m,破坏后果不严重工程地质条件简单地下水条件简单对施工影响轻微。'
        },
        {
          id:'7',
          name:'Ⅱ级',
          parentId:'5',
          features:'基坑深度6.0m<(H)<=12.0m,破坏后果严重破坏后果严重工程地质条件较复杂地下水条件较复杂对施工影响较严重。'
        },
        {
          id:'8',
          name:'Ⅲ级',
          parentId:'5',
          features:'基坑深度H>12.0m,破坏后果很严重工程地质条件复杂地下水条件复杂,对施工影响严重。'
        },
        {
          id:'9',
          name:'施工降水',
          parentId:'0'
        },
        {
          id:'10',
          name:'Ⅰ级',
          parentId:'9',
          features:'外墙轴线内包面积(F)≤1000㎡,单层地下水，渗透系数0.5m/d<(K)≤20m/d,降水深度(S△)≤7.0m,对工程环境的影响无严格要求,辅助工程措施简单。'
        },
        {
          id:'11',
          name:'Ⅱ级',
          parentId:'9',
          features:'外墙轴线内包面积1000㎡<(F)≤2000㎡,双层地下水，渗透系数0.5m/d<(K)≤50m/d,降水深度7.0m<(S△)≤13.0m,对工程环境的影响有一定要求,辅助工程措施较复杂。'
        },
        {
          id:'12',
          name:'Ⅲ级',
          parentId:'9',
          features:'外墙轴线内包面积(F)>2000㎡,多层地下水，渗透系数(K)≤0.5m/d或者(K)>50m/d,降水深度(S△)>13.0m,对工程环境的影响有严格要求,辅助工程措施复杂。'
        },

      ],
      complexityRemark: null,
      resultChinese: '',
      fileList: [],
      data: [{
       
      }],
      columns: [
      {
          title: '序',
          colKey: 'id',
          width: 90,
        },
        {
          title: '收费区间值（万元）',
          width: 100,
          colKey: '-',
          children: [
            {
              colKey: 'startValue',
              title: '起值',
              width: 100,
            },
            {
              title: '终止',
              colKey: 'finalValue',
              width: 100,
            }
          ],
        },
        {
          title: '费率',
          colKey: 'rate',
          width: 100,
        }

      ],
      complexitycolumns: [
        {
          title: '等级',
          colKey: 'name',
          width: 50,
        },
        {
          title: '工程特征',
          colKey: 'features',
          width: 180,
        }

      ],
      calculateRange:null,//计算范围
      calculationFormula:null // 计算公式

    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(){
      listFile({ classificationId: this.$route.query.ification }).then(response => {
        // console.log(response)
        this.fileList = response.rows[0];
        console.log(this.fileList)

      });
      // this.complexityCoefficientList = this.handleTreeSecond(this.complexityList)
      this.complexityCoefficientList = []
      this.complexityList.forEach(item => {
        if (item.parentId == 0){
          this.complexityCoefficientList.push(item)
        }
      })
    //   getComplexity({ ificationId: 2 }).then(res => {
    //   this.complexityList = res.data
    //   console.log(this.complexityList)
    //   res.data.forEach(item => {
    //     item.id = String(item.id)
    //   })
    //   this.complexityCoefficientList = this.handleTreeSecond(this.complexityList)
      

    //   // console.log(this.handleTree(res.data))
    // })
    listRate({ ificationId: this.$route.query.ification,pageNum: 1,pageSize: 999,}).then(res => {
      let i = 1
        res.rows.forEach((item) => {
          item.id = i++
          if (item.finalValue > 99999999){
            item.finalValue = ""
          }
          this.data.push(item)
        })
        this.data = res.rows
        
      });
      this.getClassification(this.$route.query.ification || 3).then(res => {
        if(res.data.scope){
          if (res.data.scope.indexOf("\\n")!=-1){
            this.calculateRange = res.data.scope.replaceAll('\\n', '\n')
          }else{
            this.calculateRange = res.data.scope
          }
          
        }else{
          this.calculateRange = '暂无数据'
        }
        if(res.data.particulars){
          if (res.data.particulars.indexOf("\\n")!=-1){
            this.calculationFormula = res.data.particulars.replaceAll('\\n', '\n')
          }else{
            this.calculationFormula = res.data.particulars
          }
        }else{
          this.calculationFormula = '暂无数据'
        }
      })
    },
    onReset() {
      this.$message.success('重置成功');
      console.log('formData', this.formData);
    },
    onSubmit({ validateResult, firstError }) {
      if (validateResult === true) {
        if(this.complexityCoefficient == null) {
          this.$message.warning('请选择工程复杂程度调整系数');
          return;
        }
        this.submit()
        this.$message.success('提交成功');
      } else {
        console.log('Errors: ', validateResult);
        this.$message.warning(firstError);
      }
    },
    handleClear() {
      this.helpOpen = true
    },

    submit() {
      switch (this.complexityCoefficient)
      {
        case 'Ⅰ级':
          this.formData.complexityCoefficient = 1;
          break;
        case 'Ⅱ级':
          this.formData.complexityCoefficient = 2;
          break;
        case 'Ⅲ级':
          this.formData.complexityCoefficient = 3;
          break;
      }

      this.formData.floatingRate = Number(this.floatingRate) / 100
      this.formData.discountRate = Number(this.discountRate) / 100
      getytgcsjf(this.formData).then(res => {
        this.downData = res.data
        this.formData.money = res.data.money.toString()
        this.formData.discountRateMoney = res.data.discountRateMoney.toFixed(2).toString()
        this.formData.result = res.data.result.toFixed(2).toString()
        this.formData.subtotal = res.data.subtotal.toFixed(2).toString()
        

        // this.formData.money.toString()
        this.resultChinese = this.changeNumMoneyToChinese(Number(this.formData.result))
        // this.$message.success('提交成功');
        this.jsgc = res.data.jsgc

      })





    },
    downLoad() {
      this.downLoading = true
      this.download('/project/fee/excle', { id: this.downData.id, classId: 50 }
        , `设计服务费计算.xlsx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
    downLoadWord(){
      this.downLoading = true;
      let wordParam = {
        xmmc:this.formData.projectName,
        xsz:'岩土工程概算额:' + this.formData.money + '（万元）;' + '复杂调整:' + this.complexityCoefficient + ';浮动幅度:' + this.floatingRate +  '%;折扣率:' + this.formData.discountRate + '%。',
        yjwj:this.fileList ? this.fileList.fileName.split('.')[0] : '--',
        fzcd:this.complexityCoefficient,
        fd:this.floatingRate +  '%',
        jsgc:this.jsgc,
        fulx:'岩土工程设计费',
        zhj:this.formData.result,
      }
      this.download('/project/ytgcsj/word', { id: this.downData.id, classId: 48,...wordParam }
        , `岩土工程设计收费.docx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
    resultChange(value) {
      this.resultChinese = this.changeNumMoneyToChinese(value)
    },
    
    openVisible2() {
      this.visible2 = true
    },
    close2() {
      this.visible2 = false;
    },
    onChange2(checkedValues) {
      // console.log('checkedValues:', this.value2, checkedValues.split('-').slice(-1));
      this.complexityCoefficient = checkedValues
    },
    changecomplexityCoefficient(val, context) {
      this.complexityRadioGroupList = []
      // console.log( val, context);
      // console.log('path: ', context.node.getPath());
      // this.formData.complexityCoefficientName = context.node.data.name
      this.complexityRemark = context.node.data.remark
      // console.log(this.complexityRemark)
      // this.formData.complexityCoefficient = context.node.data.name
      this.complexityList.forEach((item) => {
        if (item.parentId == val) {
          this.complexityRadioGroupList.push(item)
        }
      })
      // console.log(this.complexityRadioGroupList)

    },
    fileOpenDialog(url) {
      this.downFileUrl =  url
      let fileUrl = '/pdfjs/web/viewer.html?file=' + process.env.VUE_APP_BASE_API + url
      // window.open(fileUrl,'_blank')
      this.openFileUrl = fileUrl
      this.visible = true
    }
    // validateInput() {
    //   const value = this.formData.money;
    //   this.formData.money = value.replace(/[^0-9.]/g, ""); // 只保留数字和小数点
    // }
  },
  // directives: {
  //   digits: {
  //     bind(el) {
  //       el.addEventListener("input", function(e) {
  //         // console.log(e.data)


  //           const value = e.target.value;
  //           if (e.isComposing || value === "") return; // 避免拼音输入和空值导致删除内容
  //         e.target.value = value.replace(/[^0-9.]/g,''); // 只保留数字

  //       });
  //   }
  //   }
  // }
}
</script>

<style lang="less">
.ytgcsjf {
  background: #ffffff;
  width: 1168px;
  margin: 0 auto;
  border: 1px solid #e3e6ea;
  padding-bottom: 38px;


  

  .dialog1 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      min-width: 902px !important;
      // height: 720px !important;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;
      // padding-bottom: 32px;

      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        padding: 0;
        background: url('@/assets/dialog-background.png');

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 8px !important;
        }

        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;

          span {
            color: #000000;
          }

        }

        .t-space {
          margin-bottom: 20px;
        }
      }
    }
  }

  .dialog2 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      width: 902px;
      // height: 200px;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;


      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        background: url('@/assets/dialog-background.png');

        padding: 0;

        .t-form__label {
          height: 32px;
          line-height: 32px;
          font-family: "Regular";
        }

        .custom-cascader-1 {
          width: 300px;
        }

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 15px;
        }

        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;

          span {
            color: #000000;
          }
        }

        .complexity-table {
          padding: 20px;
          background: url('@/assets/dialog-background.png');
        }
      }
    }
  }

  .dialog3 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      width: 902px;
      height: 200px;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;
      padding-bottom: 32px;

      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        padding: 0;

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 15px;
        }

        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;

          span {
            color: #000000;
          }
        }
      }
    }
  }

}</style>

